<div class="header">
  <h1>Prompt List</h1>
</div>

<!-- check if there are even prompts -->
@if (promptList.length === 0) {
  <div>
    <p>There are no prompts to display.</p>
  </div>
}

@if (promptList.length > 0) {
  <div>
    <!-- Sort controls -->
    <div class="sort-controls">
      <div class="filter">
        <label for="flow">Filter by Flow</label>
        <select name="flow" id="flow" [(ngModel)]="contactFlowFilter">
          @for (flow of getFlowList(); track flow) {
            <option [value]="flow">
              {{ flow }}
            </option>
          }
        </select>
      </div>
      <div class="filter">
        <label for="keyword">Filter by Keyword</label>
        <select name="flow" id="keyword" [(ngModel)]="keywordFilter">
          @for (keyword of getKeywordList(); track keyword) {
            <option [value]="keyword">
              {{ keyword }}
            </option>
          }
        </select>
      </div>
    </div>
    <table class="responsive-table">
      <thead>
        <tr>
          <th rowspan="2">Flow</th>
          <th rowspan="2">Keyword</th>
          <th rowspan="2">Default Message Text</th>
          <th colspan="4">Alternate Message</th>
          <th rowspan="2">Edit</th>
        </tr>
        <tr>
          <th>Text</th>
          <th>Start</th>
          <th>End</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        @for (prompt of computedPromptList(); track prompt) {
          <tr>
            <td>{{ prompt.flow_name }}</td>
            <td>{{ prompt.keyword }}</td>
            @if (prompt.default_prompt && prompt.default_prompt !== '') {
              <td>
                {{ formatPrompt(prompt.default_prompt) }}
                <hr />
                <app-audio-player [text]="prompt.default_prompt" [api]="api"></app-audio-player>
              </td>
            }
            @if (!prompt.default_prompt && prompt.default_prompt === '') {
              <td>
                <i>No prompt</i>
              </td>
            }
            @if (prompt.custom_prompt && prompt.custom_prompt !== '') {
              <td>
                {{ formatPrompt(prompt.custom_prompt) }}
                <hr />
                <app-audio-player [text]="prompt.custom_prompt" [api]="api"></app-audio-player>
              </td>
            }
            @if (!prompt.custom_prompt && prompt.custom_prompt === '') {
              <td>
                <i>No prompt</i>
              </td>
            }
            <!-- Show 'no start time' if the prompt start time is less than 946638000 -->
            @if (prompt.start_time && prompt.start_time !== '') {
              <td>{{ getDate(prompt.start_time) }}</td>
            }
            @if (!prompt.start_time || prompt.start_time === '') {
              <td>No start time</td>
            }
            <!-- Show 'no end time' if the prompt start time is less than 946638000 -->
            @if (prompt.end_time && prompt.end_time !== '') {
              <td>{{ getDate(prompt.end_time) }}</td>
            }
            @if (!prompt.end_time || prompt.end_time === '') {
              <td>No end time</td>
            }
            <td>{{ isPromptActive(prompt) ? 'Yes' : 'No' }}</td>
            <td>
              <a routerLink="/prompts/edit/{{ prompt.flow_name }}/id/{{ prompt.keyword }}" [routerLinkActive]="['active']" class="edit">
                <p><i class="fa fa-edit"></i>Edit</p>
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
